import React from "react";
import styled, { css } from "styled-components";

const TabHeadingOuter = styled.div<ITabHeadingOuter>`
  padding: 0 ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.primary};
`;

const TabHeadingInner = styled.div<ITabHeadingInner>`
  display: inline-block;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${(props) =>
      props.isBlock &&
      css`
        display: block;
      `}
  }
`;

const TabHeadingTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes[3]};
`;

interface IOwnProps {
  title: React.ReactNode;
}

interface ITabHeadingOuter {
  hasBorder?: boolean;
  isCentered?: boolean;
}

interface ITabHeadingInner {
  isBlock?: boolean;
}

type Props = IOwnProps & ITabHeadingOuter & ITabHeadingInner;

const TabHeading: React.FC<Props> = ({
  hasBorder = false,
  isBlock = false,
  isCentered = false,
  title,
}) => (
  <TabHeadingOuter isCentered={isCentered} hasBorder={hasBorder}>
    <TabHeadingInner isBlock={isBlock}>
      <TabHeadingTitle>{title}</TabHeadingTitle>
    </TabHeadingInner>
  </TabHeadingOuter>
);

export default TabHeading;
